export const getTipoVeiculoLabel = (tipo) => {
  if (tipo === 'ELETROPONTES') return 'Eletropontes';
  if (tipo === 'PARTICULAR') return 'Particular';
  if (tipo === 'ALUGADO') return 'Alugado';
  return tipo || '';
};

export const formatNumber = (value) => {
  const numero = Number(value);
  if (!value || !Number.isFinite(numero)) return 'N/A';
  return new Intl.NumberFormat('pt-BR').format(numero);
};

export const tipoHistoricoNome = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'MANUTENCAO':
      return 'Manutenção';
    case 'LIMPEZA_VEICULAR':
      return 'Limpeza Veicular';
    case 'PECAS':
      return 'Peças';
    case 'MULTA':
      return 'Multa';
    case 'AUTUACAO':
      return 'Autuação';
    case 'REPASSE_COLABORADOR':
      return 'Repasse';
    case 'VENDA_TROCA':
      return 'Venda/Troca';
    default:
      return tipoHistorico;
  }
};

export const ordernarPorDataHistorico = (a, b) =>
  b.dataHistorico.localeCompare(a.dataHistorico);
